import { NODE_TYPES_TO_EXCLUDE_FROM_TOUR } from "@zapier/canvas-constants";

export const tourDescription = (
  nodes: any,
  nodeTypesToExcludeFromTour: typeof NODE_TYPES_TO_EXCLUDE_FROM_TOUR,
  descriptionMinChars: number,
  descriptionMaxChars: number,
) =>
  `Generate an onboarding tour for the user's canvas. The tour order will be automatically optimized, but please focus on creating a logical learning experience for users.

CRITICAL REQUIREMENT - MUST GENERATE STEPS FOR ALL NODES:
- The first step must be an intro step with stepNumber 0.
- You MUST create a tour step for ${nodes.length} nodes in the canvas data, regardless of whether it's connected or standalone.
- After tour steps are generated, you need to exclude steps for all node types from the tour that are in the ${nodeTypesToExcludeFromTour} array.
- Make sure to render annotations only above the nodes that don't have types included in the ${nodeTypesToExcludeFromTour} array.

VERY IMPORTANT:
- Each step must have a parentId that matches an existing node ID in the canvas.
- Each step's description MUST be between ${descriptionMinChars}-${descriptionMaxChars} characters.
- Keep descriptions concise but informative - focus on the key purpose of each node.
- Each step's header MUST be in sentence case: capitalize the first letter of the first word, and keep proper nouns, acronyms, and product names capitalized (e.g., "Zapier", "Zap", "Google Sheets").
   For example:
   - "notification and task creation zap" → "Notification and task creation Zap"
   - "leads table (zapier tables)" → "Leads table (Zapier Tables)"
   - "using google sheets" → "Using Google Sheets"
- The word "Zap" must always be capitalized as "Zap" in both the header and description, regardless of its position in the sentence.
`;

export const nodeDescription = (
  descriptionMinChars: number,
  descriptionMaxChars: number,
) => `Use this tool when the user asks to explain a specific node. This is for explaining ONE node only.

    You will receive data about the specific node to explain in the request context.

    CRITICAL REQUIREMENTS:
    - Generate exactly ONE explanation step for the specified node.
    - The explanation should be clear, concise, and focused on the node's purpose.
    - Header must be in sentence case with proper capitalization.
    - Description must be between ${descriptionMinChars}-${descriptionMaxChars} characters.
    - Focus on what the node does and why it's important in the workflow.
    - The word "Zap" must always be capitalized as "Zap".`;
